module.exports = __webpack_public_path__ + "img/2017-05-25.23e55715.jpg";